<template> 
    <div class="root">

        <div class="bottomTab">
            <div class="footInfo">
                <div><img src="../assets/nav-img2.png" /></div>
                <div>
                    <div><router-link to="/">公司介绍</router-link></div>
                    <div><router-link to="/product">产品中心</router-link></div>
                    <div><router-link to="/examp">案例展示</router-link></div>
                    <div><router-link to="/case">资源合作</router-link></div>
                    <div><router-link to="/welfare">爱心公益</router-link></div>
                </div>
            </div>
            <div class="IcpDiv">
                <div @click="goICP"class="mouseCursor">鲁ICP备2023025650号</div>
                <div @click="goLGA" class="mouseCursor">
                    <div><img src="../assets/nav-icon2.png" /></div>鲁公网安备37069302001036号
                </div>
                <div>版权所有：烟台衡润网络科技有限公司</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'footerNav',
        data() {
            return {

            }
        },
        mounted() {

        },
        // 方法体
        methods: {
            goICP(){
                window.open('https://beian.miit.gov.cn/');
            },
            goLGA(){
                window.open('https://beian.mps.gov.cn/#/query/webSearch?code=37069302001036');
            }
        },

    }
</script>
<style scoped>
     a {
    color: #333333;
    text-decoration: none;
  }

  .bottomTab {
            background-color: #f0f0f0;
            font-size: 1vw;
            color: #000000;
        }

        .footInfo {
            display: flex;
            align-items: center;
            padding: 2vw 8vw 12vw 8vw;
        }

        .footInfo>div:nth-child(2) {
            display: flex;
            align-items: center;
            margin-left: 10vw;
        }

        .footInfo>div:nth-child(2)>div {
            padding: 0.9vw 1.8vw;
            border-right: 0.1px solid #dfdfdf;
        }
        .footInfo>div:nth-child(2)>div:last-child {
            border: none;
        }

        .IcpDiv {
            background-color: #28BCEC;
            font-size: 0.9vw;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 1vw 0vw;
        }

        .IcpDiv>div:nth-child(2) {
            display: flex;
            align-items: center;
        }

        .IcpDiv>div:nth-child(2)>div:nth-child(1) {
            width: 0.9vw;
            height: 0.9vw;
            margin-right: 0.3vw;
        }
    /* 针对电脑端 */
    @media screen and (min-width: 1024px) {

    }

    /* 针对手机端 */
    @media screen and (max-width: 1023px) {
        .bottomTab{
            font-size: 1.5vw;
        }  .IcpDiv>div:nth-child(2)>div:nth-child(1) {
            width: 1.2vw;
            height: 1.2vw;
            margin-right: 0.3vw;
        }
        .IcpDiv{
            font-size: 1.5vw;
        }
        .footInfo{
            padding-left: 2vw;
        }
        .footInfo>div:nth-child(1){
            width: 35%;
        }
        .footInfo>div:nth-child(2){
            margin-left: 3vw;
            
            white-space: nowrap;
        }
        .footInfo>div:nth-child(2)>div {
            padding: 0.9vw 1vw;
        }
    }
</style>